import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=4e1b0cd9&scoped=true&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=4e1b0cd9&lang=scss&scoped=true&"
import style1 from "./BasePage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b0cd9",
  null
  
)

export default component.exports